<template>
    <div class="main sm:container mx-auto">
        <transition>
            <section>
                <router-view :key="$route.fullPath"></router-view>
            </section>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'Account',
    mounted() {
        this.$store.dispatch('account/fetchUserData', true)
            .then(() => this.$store.dispatch('subscription/fetchAllSubscriptions', true))
            .catch((error) => {
                console.error({ error });
                this.$store.commit('account/setError', true);
            });
    },
};
</script>
